var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThreatIntelligence = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "8.75 9.65 18.55 16.4",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m27.038 23.325-2.997-5.68c-.29-.549-.8-.93-1.39-1.059a6 6 0 0 0-.088-.47 1 1 0 0 0 .006-.113c0-.016-.007-.182-.054-.436a12.3 12.3 0 0 0-.689-2.594c-1.047-2.628-2.63-3.196-3.784-3.206h-.006a3.35 3.35 0 0 0-1.932.622c-.671.471-1.329 1.27-1.852 2.584a12.3 12.3 0 0 0-.689 2.594c-.047.254-.054.42-.054.436a1 1 0 0 0 .006.113q-.052.225-.088.47c-.59.129-1.1.51-1.39 1.059l-2.997 5.68c-.257.487-.24 1.059.044 1.531.285.471.783.753 1.334.753h1.956l-.328-4.727a1.576 1.576 0 0 1 .418-1.18c.296-.317.715-.5 1.149-.5h2.813c-.965-.373-1.413-1.015-1.617-1.271-.262-.329-.296-.802-.116-1.58.182-.784.345-1.316.485-1.677l.031-.046v.693a2.865 2.865 0 0 0 2.827 2.861h.006a2.85 2.85 0 0 0 2-.85 2.85 2.85 0 0 0 .827-2.011v-.693l.031.046c.14.36.303.893.485 1.677.18.778.146 1.251-.116 1.58-.204.256-.652.898-1.617 1.272h2.813c.434 0 .853.182 1.149.499a1.58 1.58 0 0 1 .418 1.18l-.328 4.727h1.956c.551 0 1.05-.282 1.334-.753s.3-1.044.044-1.531"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.465 20.403h-8.852a.37.37 0 0 0-.37.396l.337 4.85a.37.37 0 0 0 .37.345h8.179a.37.37 0 0 0 .369-.345l.337-4.85a.37.37 0 0 0-.37-.396"
  })));
};
export default SvgThreatIntelligence;